module.exports = __webpack_public_path__ + "img/contacts-w.2235bca3.svg";